module.exports = __webpack_public_path__ + "h5/img/naozhong.49b8d949.png";